<template>
    <ModalBase :show-modal="showModal" @close-modal="close" auto-h class="gk-modal-confirm">
        <template v-slot:titlebar>
            <TitleBar variant-class="title-modal title-modal--simple">
                <template v-slot:title>
                {{ title }}
                </template>
            </TitleBar>
        </template>

        <template v-slot:maincontent>
            <div class="target-item">
                {{ message }}
            </div>
        </template>

        <template v-slot:actions>
            <GekkoButton
                v-if="!goToSettings"
                :to="editUrl"
                :text="$gettext('Edit invoice')"
                variant="link" />
            <GekkoButton
                v-if="goToSettings"
                :href="Urls['accounts_verifactu_settings']()"
                :text="$gettext('Upload certificate')"
                variant="link" />
        </template>
    </ModalBase>
</template>

<script>
import ModalBase from "@/components/base_components/ModalBase"
import GekkoButton from "@/components/GekkoButton"
import TitleBar from "@/components/TitleBar"

export default {
    name: "VerifactuMessageModal",
    components: {
        ModalBase,
        GekkoButton,
        TitleBar
    },
    props: {
        showModal: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            required: true
        },
        message: {
            type: String,
            required: true
        },
        goToSettings: {
            type: Boolean,
            default: false
        },
        recurrentId: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
        }
    },
    computed: {
        editUrl() {
            if (this.recurrentId) {
                return { name: 'InvoiceViewRecurrent', params: { id: this.recurrentId } }
            } else {
                return { name: 'InvoiceEdit', params: { id: this.$route.params['invoiceId']} }
            }
        }
    },
    methods: {
        close() {
            this.$emit("close")
        }
    }
}
</script>